//api/units.ts

import { Unit } from "../../models/unit";
import { JsonDocument } from "./utilities/json";
import { apiProvider } from "./utilities/provider";

export const unitsApi = {
  getAll: (): Promise<Unit[]> =>
    apiProvider.getAll("units").then((d: JsonDocument<Unit[]>) => d.data),
  add: (unit: Unit): Promise<Unit> =>
    apiProvider
      .post("units", {
        data: unit,
      })
      .then((d: JsonDocument<Unit>) => d.data),
  update: (unit: Unit): Promise<Unit> =>
    apiProvider.put("units", unit.id, {
      data: unit,
    }),
};
